import { suggestions } from "./Data"

function Suggested() {
  return (
    <>
      <section id='suggested'>
        <div className='suggested-container'>
          {suggestions.map((i) => {
            return (
              <article key={i.id} className='suggested-article'>
                <div className='article-img'>
                  <img src={i.img} alt={i.title} />
                </div>
                <div className='article-info'>
                  <div class='rank'>{i.rank}</div>
                  <h2>{i.title}</h2>
                  <p>{i.subtitle}</p>
                </div>
              </article>
            )
          })}
        </div>
      </section>
    </>
  )
}

export default Suggested
